import { z } from 'zod'

export const optionalNonEmptyField = (field: z.ZodString) =>
  z.preprocess((val) => (val === '' ? undefined : val), field.optional())
